import styled from "styled-components";
import color from "constants/color";

export const FiltersRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin: 12px 0 8px;
  flex-wrap: wrap;
`;

// Base 0: os selects dividem o espaço que sobra depois dos botões de semana,
// em vez de reservarem largura fixa e empurrarem os botões para a linha de
// baixo (o gerente tem 3 selects, contra 2 do diretor).
export const FilterField = styled.div`
  flex: 1 1 0;
  min-width: 150px;
`;

export const WeekToggle = styled.div`
  display: flex;
  gap: 8px;
  flex: 0 0 auto;
`;

export const WeekButton = styled.button<{ active: boolean }>`
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid ${(props) => (props.active ? color.primary : "#d9e1ec")};
  background: ${(props) => (props.active ? color.primary : color.White)};
  color: ${(props) => (props.active ? color.White : color.gray900)};
  font-family: Inter-Medium;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.12s;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 8px 0 4px;
`;

export const FilterTitle = styled.p`
  font-family: Inter-Medium;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #98a2b3;
`;

export const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  border: none;
  background: transparent;
  color: ${color.primary};
  font-family: Inter-Medium;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
    flex: 0 0 12px;
  }

  /* O ícone de fechar é desenhado com stroke. */
  svg path {
    stroke: ${color.primary};
  }
`;

export const SectionDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 24px 0 16px;
  color: #667085;
  font-family: Inter-Medium;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e4e9f2;
  }

  svg {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
  }

  svg path[fill]:not([fill="none"]) {
    fill: ${color.primary};
  }
`;
